/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Modal } from '../../../UiKit';
import { baseSectionClass } from './constants';
import { ChevronLeft, ChevronRight } from 'sushiweb/Icons';
import { white } from 'sushiweb/tokens/color';
import {
  mediaTypes,
  sideScroll,
} from '../../widgets/ReportIssue/ComplaintMediaComp';
import { useEffect, useRef, useState } from 'react';
import Carousel from 'sushiweb/Carousel';
import { MultiMediaCarousel } from '../../../UiKit/multimedia/multimedia';
import Button from '../../ComponentsV1/Button';

const ComplaintMedia = ({ media }) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [ind, setInd] = useState(0);
  const [isOpen, toggleOpen] = useState(false);
  const [uploadedMedia, setUploadedMedia] = useState([]);

  const handleArrowClick = (direction) => {
    const element = document.getElementById('x-scroll-2');
    if (!element) return;

    if (direction === 'left' && !showLeftArrow) return;
    if (direction === 'right' && !showRightArrow) return;

    sideScroll(
      element,
      direction,
      20,
      450,
      30,
      setShowLeftArrow,
      setShowRightArrow,
    );
  };

  const handleClick = (index) => () => {
    toggleOpen(true);
    setInd(index);
  };

  const handleClose = () => toggleOpen(false);

  useEffect(() => {
    setInd(0);
  }, [media, media?.length]);

  useEffect(() => {
    const formattedMedia = media?.map((item) => ({
      src: item?.url,
      type: item?.type,
    }));
    setUploadedMedia(formattedMedia);
  }, [media]);

  useEffect(() => {
    const scroller2 = document.getElementById('x-scroll-2');
    if (scroller2) {
      scroller2.scrollLeft = 0;
      setShowLeftArrow(false);
      if (scroller2.scrollWidth - scroller2.clientWidth > 0)
        setShowRightArrow(true);
      else setShowRightArrow(false);
    }
  }, [media]);

  return (
    <div className={`${baseSectionClass} tw-p-4`}>
      <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
        <span className='tw-uppercase tw-text-grey-500 tw-text-[1.2rem]'>
          Complaint Media
        </span>
        <div
          className='tw-flex tw-gap-4 tw-w-full  tw-overflow-x-scroll tw-items-center'
          id='x-scroll-2'
          css={`
            ::-webkit-scrollbar {
              display: none;
            }
          `}
        >
          {/* Left scroll arrow */}
          <div
            className={`tw-flex tw-items-start tw-justify-center tw-rounded-full tw-ml-5 tw-absolute tw-left-0 tw-z-30 ${
              showLeftArrow
                ? 'tw-bg-grey-700 tw-cursor-pointer'
                : 'tw-bg-grey-200 tw-cursor-not-allowed'
            }`}
            css={`
              & i {
                position: relative;
                left: -1px;
              }
            `}
            onClick={() => handleArrowClick('left')}
          >
            <ChevronLeft size={25} color={white} />
          </div>
          {media?.map((data, mapIndex) => {
            if (!data?.url) return null;
            return (
              <div
                className='tw-flex tw-items-center tw-justify-center tw-pt-5 tw-px-0  tw-gap-3 tw-w-64 tw-cursor-pointer'
                key={data.url}
              >
                <div
                  className='tw-gap-3 tw-w-64 tw-h-64 tw-relative tw-overflow-hidden tw-rounded-xl tw-border-2 tw-border-solid tw-border-grey-200'
                  onClick={handleClick(mapIndex)}
                  data-dd-privacy='hidden'
                >
                  {data.type === mediaTypes['image'] ? (
                    <img
                      src={data.url}
                      className='tw-w-full tw-h-full'
                      alt='Complaint Media'
                    />
                  ) : (
                    <video
                      src={data.url}
                      controls
                      autoPlay
                      muted
                      className='tw-w-full tw-h-full'
                    />
                  )}
                </div>
              </div>
            );
          })}
          {/* Right scroll arrow */}
          <div
            className={`tw-flex tw-items-start tw-justify-center tw-rounded-full tw-mr-5 tw-absolute tw-right-0 ${
              showRightArrow
                ? 'tw-bg-grey-700 tw-cursor-pointer'
                : 'tw-bg-grey-200 tw-cursor-not-allowed'
            }`}
            css={`
              & i {
                position: relative;
                right: -1px;
              }
            `}
            onClick={() => handleArrowClick('right')}
          >
            <ChevronRight size={25} color={white} />
          </div>
        </div>
      </div>
      {/* Media viewer modal */}
      {isOpen && (
        <Modal
          isMaxContent
          maxHeight='82vh'
          isVisible={isOpen}
          type='large'
          title={'Session Media'}
          handleClose={handleClose}
          containerStyles={{ padding: 'auto' }}
          component={
            <Carousel
              showComponent={true}
              componentData={uploadedMedia || []}
              componentToRender={MultiMediaCarousel}
              defaultTheme={false}
              currentIndex={ind}
              dots={false}
              infinite={false}
              width='100%'
            />
          }
        />
      )}
    </div>
  );
};

const SessionDisposition = ({ disposition }) => {
  return (
    <div className='tw-text-lg tw-w-1/2 tw-font-medium tw-flex tw-flex-col tw-leading-none tw-gap-2 '>
      <span className='tw-uppercase tw-text-grey-500 tw-text-[1.2rem] tw-leading-none'>
        Agent Information
      </span>
      <span className='tw-capitalize tw-text-[1.4rem] tw-text-grey-800 tw-leading-tight'>
        {Array.isArray(disposition) && disposition.length > 0 ? (
          <div className='tw-flex tw-flex-col tw-items-start tw-gap-1'>
            Manual Agent connected
            <span>
              <strong>Disposition: </strong>
              {disposition.map((item) => item).join(', ')}
            </span>
          </div>
        ) : (
          'No Manual Agent connected'
        )}
      </span>
    </div>
  );
};

const CustomerComment = ({ comments }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const commentRef = useRef(null);

  useEffect(() => {
    if (!commentRef?.current || isExpanded) return;
    const element = commentRef.current;
    const hasOverflow = element.scrollHeight > element.clientHeight + 1;
    setIsTruncated(hasOverflow);
  }, [comments, isExpanded]);

  return (
    <div className='tw-text-lg tw-font-medium tw-flex tw-flex-col tw-leading-none tw-gap-2 tw-w-1/2'>
      <span className='tw-uppercase tw-text-grey-500 tw-text-[1.2rem]'>
        Customer Comments
      </span>
      <span
        ref={commentRef}
        className={`tw-text-[1.4rem] tw-text-grey-800 tw-leading-tight tw-pr-2 ${
          isExpanded
            ? 'tw-max-h-none tw-overflow-visible'
            : 'tw-overflow-hidden tw-text-ellipsis tw-line-clamp-3'
        }`}
      >
        {comments || 'No comment available'}
      </span>
      {isTruncated && comments && (
        <Button
          title={isExpanded ? 'Show less' : 'Show more'}
          type='link'
          className='tw-text-[1.3rem] tw-leading-none tw-text-base-green tw-font-medium tw-w-fit !tw-bg-grey-100/70'
          onClick={() => setIsExpanded((prev) => !prev)}
        />
      )}
    </div>
  );
};

const AgentComments = ({ comments }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const agentCommentRef = useRef(null);

  useEffect(() => {
    if (!agentCommentRef?.current || isExpanded) return;
    const element = agentCommentRef.current;
    const hasOverflow = element.scrollHeight > element.clientHeight + 1;
    setIsTruncated(hasOverflow);
  }, [comments, isExpanded]);

  return (
    <div className='tw-text-lg tw-w-1/2 tw-font-medium tw-flex tw-flex-col tw-leading-none tw-gap-2'>
      <span className='tw-uppercase tw-text-grey-500 tw-text-[1.2rem] tw-leading-none'>
        Agent Comments
      </span>
      {Array.isArray(comments) && comments.length > 0 ? (
        <div
          ref={agentCommentRef}
          className={`tw-text-[1.4rem] tw-text-grey-800 tw-leading-tight ${
            isExpanded
              ? 'tw-max-h-none tw-overflow-visible'
              : 'tw-overflow-hidden tw-text-ellipsis tw-line-clamp-3'
          }`}
          style={{ wordBreak: 'break-all', overflowWrap: 'break-word' }}
        >
          {comments.map((item, index) => (
            <li
              key={item}
              className={index !== comments.length - 1 ? 'tw-mb-2' : ''}
              style={{ wordBreak: 'break-all', overflowWrap: 'break-word' }}
            >
              {item}
            </li>
          ))}
        </div>
      ) : (
        <span className='tw-text-[1.4rem] tw-text-grey-800 tw-leading-tight'>
          No comment available
        </span>
      )}
      {isTruncated && Array.isArray(comments) && comments.length > 0 && (
        <Button
          title={isExpanded ? 'Show less' : 'Show more'}
          type='link'
          className='tw-text-[1.3rem] tw-leading-none tw-text-base-green tw-font-medium tw-w-fit !tw-bg-grey-100/70'
          onClick={() => setIsExpanded((prev) => !prev)}
        />
      )}
    </div>
  );
};

const SessionComplaintType = ({ complainType, node }) => {
  return (
    <div className='tw-text-lg tw-m-4 tw-font-medium tw-flex tw-leading-none tw-gap-3 tw-w-[92%]'>
      <span className='tw-uppercase tw-text-grey-500 tw-text-[1.2rem] tw-leading-none tw-whitespace-nowrap tw-mt-px'>
        {complainType ? 'Complaint Type' : 'Complaint Node'}
      </span>
      <span className='tw-text-[1.4rem] tw-text-grey-800 tw-whitespace-nowrap'>
        {complainType || node || 'N/A'}
      </span>
    </div>
  );
};

export {
  CustomerComment,
  ComplaintMedia,
  SessionDisposition,
  SessionComplaintType,
  AgentComments,
};
